
import api from './api';

export const fetchAllItems = async (includeInactive = false) => {
  try {
    const response = await api.get('/items', { params: { includeInactive } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch items:', error);
    throw new Error('Failed to fetch items');
  }
};


export const fetchAllItemsByPartnerId = async (id) => {
  try {
    const response = await api.get(`/items/partner/${id}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch items:', error);
    throw new Error('Failed to fetch items');
  }
};


export const fetchAllKeyword = async () => {
  try {
    const response = await api.get('/keyword-master/Category');
    return response.data;

  } catch (error) {
    console.error('Failed to fetch items:', error);
    throw new Error('Failed to fetch items');
  }
};

export const fetchKeywordsByType = async (type = 'Category') => {
  try {
    const response = await api.get(`/keyword-master/${type}`);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch keywords for type ${type}:`, error);
    throw error;
  }
};

export const fetchPartnerOrdersByStatus = async (status, page = 1, limit = 10) => {
  try {
    const response = await api.get(`/orders/partner/${status}`, { params: { page, limit } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch partner orders by status:', error);
    throw new Error('Failed to fetch partner orders by status');
  }
};

export const fetchAllAddresses = async () => {
  try {
    const response = await api.get('/address');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch addresses:', error);
    throw new Error('Failed to fetch addresses');
  }
}

export const fetchAddressesByClientId = async (clientId) => {
  try {
    const response = await api.get(`/address/partner/${clientId}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch addresses by clientId:', error);
    throw new Error('Failed to fetch addresses by clientId');
  }
};

export const fetchInProgressOrders = async ()=>{
  try {
    const response = await api.get('/orders/inprogress-count');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch in progress orders:', error);
    throw new Error('Failed to fetch in progress orders');
  }
}


export const getAllOrders = async ( page = 1, limit = 10) => {
  try {
    const response = await api.get(`/orders/all-active`, { params: { page, limit } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch orders by status:', error);
    throw new Error('Failed to fetch orders by status');
  }
};


export const getOrdersByStatus = async ( status, page = 1, limit = 100) => {
  console.log(limit);
  try {
    const response = await api.get(`/orders/status/${status}`, { params: { page, limit } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch partner orders by status:', error);
    throw new Error('Failed to fetch partner orders by status');
  }
};


export const fetchAllClient = async () => {
  try {
    const response = await api.get('/partners');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch client:', error);
    throw new Error('Failed to fetch client');
  }
};


export const fetchAllStocks = async (includeInactive = false) => {
  try {
    const response = await api.get('/stock', { params: { includeInactive } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch stocks:', error);
    throw new Error('Failed to fetch stocks');
  }
};


export const fetchStockTransactions = async (itemId) => {
  try {
    const response = await api.get(`/stock/transactions/${itemId}`); // Adjust the API endpoint URL as needed
    return await response.data; 
  } catch (error) {
    console.error("Error fetching stock transactions:", error);
    throw new Error('Failed to fetch stock transactions');
  }
};

export const fetchLockedStock = async () => {
  try {
    const response = await api.get('/stock/lock-stock-item-wise');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch locked stock:', error);
    throw new Error('Failed to fetch locked stock');
  }
}
export const fetchClientsDetails = async () =>{
  try {
    const response = await api.get('/partners');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch clients details:', error);
    throw new Error('Failed to fetch clients details');
  }
}


export const fetchClientDetail = async (id) =>{
  console.log(id);
  try {
    const response = await api.get(`/partners/${id}`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch client detail:', error);
    throw new Error('Failed to fetch client detail');
  }
}

export const fetchAdminDashboardCountData = async (startDate, endDate) => { 
  try {
    const response = await api.get('/dashboard/stats', { params: { startDate, endDate } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch admin dashboard count data:', error);
    throw new Error('Failed to fetch admin dashboard count data');
  }
}

export const fetchOrderSales = async (startDate, endDate, period) => {  
  try {
    const response = await api.get('/dashboard/order-stats', { params: { startDate, endDate, period } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch order sales:', error);
    throw new Error('Failed to fetch order sales');
  }
}

export const fetchProductList = async (startDate, endDate) => {
  try {
    const response = await api.get('/dashboard/item-sales', { params: { startDate, endDate } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch product list:', error);
    throw new Error('Failed to fetch product list');
  }
}

export const fetchPartnerSales = async (startDate, endDate) => {
  try {
    const response = await api.get('/dashboard/partner-sales', { params: { startDate, endDate } });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch partner sales:', error);
    throw new Error('Failed to fetch partner sales');
  }
}



export const  getAllComplaints =  async() => {
  try {
    const response = await api.get('/complaints');
    return response.data;
  } catch (error) {
    console.error('Error fetching complaints:', error);
    throw error;
  }
}

export const  getAllComplaintById =  async(id) => {
  try {
    const response = await api.get(`/complaints/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching complaint:', error);
    throw error;
  }
}



export const  getComplaintCategory =  async() => {
  try {
    const response = await api.get('/complaints/categories/all');
    return response.data;
  } catch (error) {
    console.error('Error fetching complaints:', error);
    throw error;
  }
}

export const  getAllIssueOfCategory =  async(id) => {
  try {
    const response = await api.get(`/complaints/categories/${id}/issues`);
    return response.data;
  } catch (error) {
    console.error('Error fetching Issues:', error);
    throw error;
  }
}

  export const  getComplaintStatusHistory =  async(id) => {
    try {
      const response = await api.get(`/complaints/${id}/status`);
      return response.data;
    } catch (error) {
      console.error('Error fetching complaints:', error);
      throw error;
    }
}


export const fetchItemsByPartnerId = async (partnerId) => {
  if (!partnerId) {
    console.error("Error: Partner ID is missing");
    throw new Error("Partner ID is required");
  }
  try {
    const response = await api.get(`/items/partner/${partnerId}`);
    console.log("API Response:", response.data);
    return response.data;
  } catch (error) {
    console.error(`Failed to fetch items by partner ID ${partnerId}:`, error);
    throw new Error(`Failed to fetch items for Partner ID: ${partnerId}`);
  }
};

export const fetchFranchiseOverview = async () => {
  try {
    const response = await api.get('/franchise_dashboard/overview');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch franchise overview:', error);
    throw error;
  }
};


export const fetchFranchiseOutlets = async (status) => {
  try {
    const response = await api.get('/franchise_dashboard/outlets', {
      params: status && status !== 'All' ? { status } : {},
    });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch outlets:', error);
    throw error;
  }
};

export const fetchOutletDeepDrive = async (outletName) => {
  const res = await api.get(
    `/franchise_dashboard/outlet/${encodeURIComponent(outletName)}`
  );
  return res.data;
};



export const fetchAlerts = async () => {
  const res = await api.get(
    '/franchise_dashboard/alerts'
  );
  return res.data;
};

export const fetchLeaderboard = async () => {
  try {
    const res = await api.get('/franchise_dashboard/leaderboard');
    return res.data;
  } catch (error) {
    console.error('Failed to fetch leaderboard:', error);
    throw error;
  }
};

// ---- POS Dashboard ----

// The server may run in a different timezone than the admin viewing the
// dashboard (e.g. a UTC container), so we always tell it what "today" means
// from the browser's own local clock rather than letting it assume its own.
// Built from local getFullYear/getMonth/getDate (not toISOString, which
// converts to UTC first and can silently roll the date over near midnight).
const getLocalDateString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Shared by every POS dashboard endpoint that filters by the global period
// picker in the header - keeps the "period=custom needs startDate/endDate,
// everything needs today's local date" logic in one place.
const buildPeriodParams = ({ period, startDate, endDate } = {}) => {
  const params = { period: period || 'today', date: getLocalDateString() };
  if ((period || 'today') === 'custom') {
    params.startDate = startDate;
    params.endDate = endDate;
  }
  return params;
};

export const fetchPosPartners = async ({ period, startDate, endDate } = {}) => {
  try {
    const params = buildPeriodParams({ period, startDate, endDate });
    const response = await api.get('/pos/dashboard/partners', { params });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch POS partners:', error);
    throw error;
  }
};

export const fetchPosOrders = async ({
  partnerId,
  search,
  page = 1,
  pageSize = 10,
  period,
  startDate,
  endDate,
} = {}) => {
  try {
    const params = { ...buildPeriodParams({ period, startDate, endDate }), page, pageSize };
    if (partnerId && partnerId !== 'all') params.partnerId = partnerId;
    if (search) params.search = search;
    const response = await api.get('/pos/dashboard/orders', { params });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch POS orders:', error);
    throw error;
  }
};

export const fetchPosPeriodSales = async ({ period, startDate, endDate, partnerId } = {}) => {
  try {
    const params = buildPeriodParams({ period, startDate, endDate });
    if (partnerId && partnerId !== 'all') params.partnerId = partnerId;
    const response = await api.get('/pos/dashboard/period-sales', { params });
    return response.data;
  } catch (error) {
    console.error('Failed to fetch POS period sales:', error);
    throw error;
  }
};

// --- Employee Management ---------------------------------------------------

export const fetchAllEmployees = async () => {
  try {
    const response = await api.get('/admin/employees');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch employees:', error);
    throw error;
  }
};

export const fetchAllRoles = async () => {
  try {
    const response = await api.get('/kitchen/admin/roles');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch roles:', error);
    throw error;
  }
};

// --- Application Access ------------------------------------------------

export const fetchApplications = async () => {
  try {
    const response = await api.get('/admin/applications');
    return response.data;
  } catch (error) {
    console.error('Failed to fetch applications:', error);
    throw error;
  }
};

export const fetchPartnerAppAccess = async (partnerId) => {
  try {
    const response = await api.get(`/admin/partners/${partnerId}/app-access`);
    return response.data;
  } catch (error) {
    console.error('Failed to fetch partner app access:', error);
    throw error;
  }
};
